import type { PageTour } from '../types';

export const newsTour: PageTour = {
  id: 'news',
  label: 'News Tour',
  steps: [
    {
      target: '[data-tour="news-header"]',
      title: 'Company News',
      content: 'Stay up to date with the latest company announcements, updates, and articles.',
    },
    {
      target: '[data-tour="news-create"]',
      title: 'Create an Article',
      content: 'Share news with your organization. Write and publish articles for your team or the entire company.',
    },
    {
      target: '[data-tour="news-list"]',
      title: 'News Feed',
      content: 'Browse all published articles. Each card shows the title, author, date, and a preview of the content.',
    },
    {
      target: '[data-tour="news-sidebar"]',
      title: 'Categories & Tags',
      content: 'Filter news by category or tag to find articles relevant to your interests.',
    },
  ],
};
